// assets
import { IconDashboard, IconKey } from "@tabler/icons";
import PolicyIcon from "@mui/icons-material/Policy";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import WebIcon from "@mui/icons-material/Web";
import LanguageIcon from "@mui/icons-material/Language";
import StoreIcon from "@mui/icons-material/Store";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SupportAgent from "@mui/icons-material/SupportAgent";


// constant
const icons = {
  IconDashboard,
  IconKey,
  PolicyIcon,
  ProductionQuantityLimitsIcon,
  WebIcon,
  StoreIcon,
  SentimentSatisfiedAltIcon,
  SupportAgent,
  LanguageIcon,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const storedPermissions = localStorage.getItem('allPermissions');
const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];

const hasPermission = (permission) => {
  return permissions.includes(permission);
};

const dashboard = {
  id: "dashboard",
  title: "Admin Dashboard",
  type: "group",
  children: [
    {
      id: "website",
      title: "Website",
      type: "item",
      url: "https://farmershop.co.in/",
      icon: icons.LanguageIcon,
      breadcrumbs: false,
      target: "_blank",
    },
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: icons.WebIcon,
      breadcrumbs: false,
      visible: hasPermission('read-roles'),
    },
    {
      id: "customer",
      title: "Customer",
      type: "collapse",
      icon: icons.SentimentSatisfiedAltIcon,
      visible: hasPermission('read-customers'),
      children: [
        {
          id: "customer",
          title: "Customer List",
          type: "item",
          url: "customer",
        },
      ],
    },
    {
      id: "product",
      title: "Product",
      type: "collapse",
      icon: icons.ProductionQuantityLimitsIcon,
      visible: hasPermission('read-products'),
      children: [
        {
          id: "category",
          title: "Category",
          type: "item",
          url: "/category",
        },
        {
          id: "subCategory",
          title: "Sub Category",
          type: "item",
          url: "/subCategory",
        },
        {
          id: "brands",
          title: "Brand",
          type: "item",
          url: "/brands",
        },
        {
          id: "products",
          title: "List",
          type: "item",
          url: "/products",
        },
      ],
    },
    {
      id: "store",
      title: "Store",
      type: "collapse",
      icon: icons.StoreIcon,
      visible: hasPermission('read-store'),
      children: [
        {
          id: "store2",
          title: "Stores",
          type: "item",
          url: "/store",
          visible: hasPermission('read-store'),
        },
        {
          id: "allemployees",
          title: "Employees",
          type: "item",
          url: "/allemployees",
        },
        // {
        //   id: "verification",
        //   title: "Verification",
        //   type: "item",
        //   url: "/verification",
        // },
        {
          id: "online-history",
          title: "Online History",
          type: "item",
          url: "/onlinehistory",
          visible: hasPermission('read-onlinehistory'),
        },
        {
          id: "open-history",
          title: "Open History",
          type: "item",
          url: "/openhistory",
          visible: hasPermission('read-openhistory'),
        },
        {
          id: "document-type",
          title: "Document Type",
          type: "item",
          url: "/document-type",
          visible: hasPermission('read-documenttype'),
        },
        {
          id: "control",
          title: "Permission",
          type: "item",
          url: "/control",
          visible: hasPermission('read-all-permissions'),
        },
      ],
    },
    {
      id: "policies",
      title: "Policies",
      type: "collapse",
      icon: icons.PolicyIcon,
      visible: hasPermission('read-policies'), // Example permission check
      children: [
        {
          id: "list-policies",
          title: "List",
          type: "item",
          url: "/policies",
        },
        {
          id: "history",
          title: "History",
          type: "item",
          url: "/history",
        },
      ],
    },
    {
      id: "support",
      title: "Support",
      type: "collapse",
      icon: icons.SupportAgent,
      visible: hasPermission('read-support'), // Example permission check
      children: [
        {
          id: "ticket",
          title: "Ticket",
          type: "item",
          url: "/ticket",
        },
        {
          id: "mail",
          title: "Chat",
          type: "item",
          url: "/email",
        },
      ],
    },
  ],
};

// Filter out items where `visible` is `false`
dashboard.children = dashboard.children.filter(item => item.visible !== false);
dashboard.children.forEach(group => {
  if (group.children) {
    group.children = group.children.filter(item => item.visible !== false);
  }
});

export default dashboard;
